import React from 'react';
import '../App.css'; 

const Logo = () => {
  return (
    <div className="logo-wrapper">
      <h1 className="logo-text">Teeth for Tous</h1>
      <div className="logo-underline"></div>
    </div>
  );
};

export default Logo;
